import { render, staticRenderFns } from "./StandardItemManage.vue?vue&type=template&id=289f7cf3&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./StandardItemManage.vue?vue&type=script&lang=js"
export * from "./StandardItemManage.vue?vue&type=script&lang=js"
import style0 from "./StandardItemManage.vue?vue&type=style&index=0&id=289f7cf3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f7cf3",
  null
  
)

export default component.exports